import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { HardcodedFooter } from '@invitae/header-footer';
import { usePageAnalyticsContext } from '@invitae/nucleobase-analytics';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { usePageAnalytics } from './Page.hooks.esm.js';

/**
 * Calculates Page signature.
 * Page signautre reflects order of sections and version of each section
 * @param sections - array of page sections
 * @returns pageSignature in form `<section_id>:<section_revision>;<another_section_id>:<another_section_revision>'....`
 */
function getPageSignature(sections) {
    var pageSignature = sections.map(function (s) { return "".concat(s.sys.id, ":").concat(s.sys['revision'] || 0); }).join(';');
    return pageSignature;
}
var Page = function (_a) {
    var _b = _a.fields, sections = _b.sections, analyticsEvents = _b.analyticsEvents, path = _b.path, layout = _b.layout; 
    // `id` === Contentful's Page Layout id;
    _a.id; var props = __rest(_a, ["fields", "id"]);
    var pageAnalytics = usePageAnalyticsContext();
    usePageAnalytics({
        analyticsEvents: analyticsEvents || [],
        pageSignature: getPageSignature(sections),
        siteLocation: (pageAnalytics && pageAnalytics['Site location']) || '',
        url: path || '',
    });
    var renderHeader = React.useCallback(function () {
        if (!layout.fields.navigation && !layout.fields.header) {
            return null;
        }
        if (layout.fields.header) {
            return (React.createElement(BaseNucleobaseComponent, { BaseComponent: BaseNucleobaseComponent, headerVariation: layout.fields.headerVariation, source: layout.fields.header }));
        }
        else if (layout.fields.navigation) {
            return React.createElement(BaseNucleobaseComponent, { BaseComponent: BaseNucleobaseComponent, source: layout.fields.navigation });
        }
    }, [layout.fields.navigation, layout.fields.header]);
    var renderNotificationBanner = React.useCallback(function () {
        if (!layout.fields.notificationBanner) {
            return null;
        }
        return React.createElement(BaseNucleobaseComponent, { source: layout.fields.notificationBanner });
    }, [layout.fields.notificationBanner]);
    var renderFooter = React.useCallback(function () {
        if (layout.fields.footer) {
            return React.createElement(BaseNucleobaseComponent, { source: layout.fields.footer });
        }
        return React.createElement(HardcodedFooter, null);
    }, [layout.fields.footer]);
    var sectionsWithName = sections.map(function (section) {
        var _a, _b, _c;
        return __assign(__assign({}, section), { componentName: (_c = (_b = (_a = section === null || section === void 0 ? void 0 : section.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id });
    });
    return (React.createElement(React.Fragment, null,
        renderHeader(),
        renderNotificationBanner(),
        React.createElement("main", null, sectionsWithName.map(function (section, key) { return (React.createElement(BaseNucleobaseComponent, __assign({ "data-cy": "section-".concat(section.componentName, "-").concat(key), key: "page_section_".concat(key), source: section }, props))); })),
        renderFooter()));
};

export { Page as default };
//# sourceMappingURL=Page.esm.js.map
